import { createSlice } from "@reduxjs/toolkit";
import { getAgentLevelScoringVsSentimentList, getAgentViolationList, getPurposeOfCallDistributionList } from "../services/agent.service";
import { agentViolationListData } from "../views/agent/mock/agent-violation-list-data";
import { agentPerformanceDashboard } from "../views/agent/mock/dashboard-performance-mock";
import { purposeOfCallDistributionCardData } from "../views/agent/mock/purpose_od_Call_Distribution_list_data";

  const initialState = {
  agentViolationLoader: false,
  agentLevelScoringVsSentimentLoader: false,
  purposeOfCallDistributionLoader: false,
  agentViolationList: [], 
  agentLevelScoringVsSentimentList: [],
  purposeOfCallDistributionList: [],
  agentViolationSuccessMsg: '',
  agentViolationErrorMsg: '',
  agentLevelScoringVsSentimentSuccessMsg: '',
  agentLevelScoringVsSentimentErrorMsg: '',
  purposeOfCallDistributionSuccessMsg: '',
  purposeOfCallDistributionErrorMsg: ''
};

const AgentSlice = createSlice({
  name: "knowledge-base-list",
  initialState: initialState,
  reducers: {
    clearUserMessages: (state) => {
      // Clear all success/error messages
      state.agentViolationSuccessMsg = '';
      state.agentViolationErrorMsg = '';
    },

   
  },
  extraReducers: (builder) => {
    builder     
      .addCase(getAgentViolationList.pending, (state, action) => {
        state.agentViolationLoader = true;
      })
      .addCase(getAgentViolationList.fulfilled, (state, action: any) => {
        state.agentViolationLoader = false;
        state.agentViolationList = action.payload.results;
      })
      .addCase(getAgentViolationList.rejected, (state: any , action) => {
        state.agentViolationLoader = false;
        state.agentViolationList = agentViolationListData; //temp
        state.agentViolationErrorMsg = action.error?.message || "Failed to load agent violation list";
      })
      //agent level scoring vs sentiment
      .addCase(getAgentLevelScoringVsSentimentList.pending, (state, action) => {
        state.agentViolationLoader = true;
      })
      .addCase(getAgentLevelScoringVsSentimentList.fulfilled, (state, action: any) => {
        state.agentViolationLoader = false;
        state.agentViolationList = action.payload.results;
      })
      .addCase(getAgentLevelScoringVsSentimentList.rejected, (state: any , action) => {
        state.agentViolationLoader = false;
        state.agentLevelScoringVsSentimentList = agentPerformanceDashboard; //temp
        state.agentViolationErrorMsg = action.error?.message || "Failed to load agent violation list";
      })
       //purpose of call distribution
       .addCase(getPurposeOfCallDistributionList.pending, (state, action) => {
        state.purposeOfCallDistributionLoader = true;
      })
      .addCase(getPurposeOfCallDistributionList.fulfilled, (state, action: any) => {
        state.purposeOfCallDistributionLoader = false;
        state.agentViolationList = action.payload.results;
      })
      .addCase(getPurposeOfCallDistributionList.rejected, (state: any , action) => {
        state.purposeOfCallDistributionLoader = false;
        state.purposeOfCallDistributionList = purposeOfCallDistributionCardData; //temp
        state.agentViolationErrorMsg = action.error?.message || "Failed to load agent violation list";
      })
    
  },
});

export default AgentSlice.reducer;
export const { clearUserMessages  } = AgentSlice.actions;
